import React from "react";

import { IgButton, IgDialog, IgTypography } from "@intelligems/ig-theme";
import {
  CreateBillingRequestBodyType,
  UpgradeBillingRequestBodyType,
} from "@intelligems/ig-types";
import { List, ListItem } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useCurrentPriceVersion } from "@src/api/intelligems/get-live-prices";
import { useAdjustBilling } from "@src/api/stripe/adjust-billing";
import { useLoggedInUser } from "@src/api/user-auths/login";
import { useDialog } from "@src/hooks/dialog";

export const UpgradeProfitOptimizationDialog = () => {
  const dialog = useDialog("upgradeToProfitOptimization");
  const user = useLoggedInUser();

  const version = useCurrentPriceVersion();
  const adjustBilling = useAdjustBilling();

  const profitOptDemoURL = `https://www.intelligems.io/book-a-demo-in-app?lastname=${user.data?.user.lastName}&firstname=${user.data?.user.firstName}&email=${user.data?.user.email}&domain=${user.data?.organization.domain}`;

  if (!dialog.props) {
    return null;
  }

  const body: UpgradeBillingRequestBodyType | CreateBillingRequestBodyType = {
    couponId: dialog?.props?.couponId,
    stripeSubscriptionLinkId: dialog.props.stripeSubscriptionLinkId,
    action: dialog?.props?.action,
    priceIds: dialog?.props?.priceIds,
    version,
  };

  return (
    <IgDialog
      dialogHeight={null}
      maxWidth={"sm"}
      dialogContentWidth={"480px"}
      showDialog={dialog.isOpen}
      handleClose={dialog.close}
      title={"Upgrade Your Plan"}
      hideActions={true}
      content={
        <Grid container direction={"column"}>
          <Grid container direction={"column"} textAlign={"start"}>
            <Grid>
              <IgTypography>
                Let's start testing prices, shipping rates and offers!
              </IgTypography>
            </Grid>
            <br />
            <Grid>
              <IgTypography>
                We highly recommend meeting with us before you get going -
                customers who do this get 28% more impact from Intelligems.
                Scheduling is easy and we can usually talk within 24 hours. We
                can help you:
              </IgTypography>
            </Grid>
            <Grid container direction={"column"} mt={1} mb={2}>
              <List sx={{ listStyleType: "disc", marginLeft: "30px" }}>
                <ListItem sx={{ display: "list-item", padding: 0 }}>
                  <IgTypography>
                    Set up the necessary integrations (for free!) and understand
                    technical requirements
                  </IgTypography>
                </ListItem>
                <ListItem sx={{ display: "list-item", padding: 0 }}>
                  <IgTypography>QA your first test</IgTypography>
                </ListItem>
                <ListItem sx={{ display: "list-item", padding: 0 }}>
                  <IgTypography>
                    Discover advanced features you may not know about
                  </IgTypography>
                </ListItem>
                <ListItem sx={{ display: "list-item", padding: 0 }}>
                  <IgTypography>
                    Develop a strategy and roadmap to maximize profit
                  </IgTypography>
                </ListItem>
              </List>
            </Grid>
          </Grid>
          <Grid>
            <IgButton
              onClick={() => {
                window.open(profitOptDemoURL, "_blank");
                dialog.close();
              }}
              variant={"contained"}
            >
              Unlock Expert Guidance
            </IgButton>
          </Grid>
          <Grid>
            <IgButton
              loading={adjustBilling.isPending}
              onClick={() => {
                adjustBilling.mutate({
                  pathParams: undefined,
                  queryParams: undefined,
                  body,
                });
              }}
            >
              Continue without expert help
            </IgButton>
          </Grid>
        </Grid>
      }
    />
  );
};
